export const getErrorMessage = (error: any, defaultMsg: string = "Create failed") => {
    const msg =
      error?.msg ||
      error?.response?.data?.msg ||
      error?.response?.data?.message ||
      error?.message ||
      defaultMsg;
    return msg;
};
